export function extractSurrealId(surrealId: string): string {
  const id = surrealId.split(":")[1];
  if (id === undefined) {
    throw new Error("Invalid surreal id");
  }
  return id;
}

export function createSurrealId(table: string, id: string): string {
  return `${table}:${id}`;
}
